/**
 * Cron Parser Command
 * Parse and explain cron expressions
 */
import { Command } from 'commander';
import cronstrue from 'cronstrue';

async function handleCronParse(expression: string): Promise<void> {
    try {
        // Parse cron expression to human-readable
        const description = cronstrue.toString(expression);

        console.log('⏰ Cron Expression Parser:');
        console.log('────────────────────────────────────────');
        console.log(`   Expression: ${expression}`);
        console.log(`   Meaning: ${description}`);
        console.log();

        // Calculate next 5 execution times
        console.log('📅 Next 5 Executions:');

        const parts = expression.trim().split(/\s+/);
        if (parts.length < 5 || parts.length > 6) {
            console.log('   ⚠️  Invalid cron expression format');
            return;
        }

        // Simple calculation for next runs (approximate)
        const now = new Date();
        const executions: string[] = [];

        for (let i = 0; i < 5; i++) {
            const nextTime = new Date(now);
            nextTime.setDate(nextTime.getDate() + i);

            // Try to match hour and minute from cron
            const [minute, hour] = parts.slice(parts.length === 6 ? 1 : 0, parts.length === 6 ? 3 : 2);

            if (minute !== '*' && !minute.includes('/') && !minute.includes('-')) {
                nextTime.setMinutes(parseInt(minute, 10));
            }

            if (hour !== '*' && !hour.includes('/') && !hour.includes('-')) {
                nextTime.setHours(parseInt(hour, 10));
            }

            executions.push(
                `   ${i + 1}. ${nextTime.toISOString().replace('T', ' ').substring(0, 19)}`
            );
        }

        executions.forEach((exec) => console.log(exec));
        console.log();

        console.log('💡 Tip: This is an approximate calculation.');
        console.log('   For exact times, consider your system timezone.');
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createCronCommand(): Command {
    const cmd = new Command('cron')
        .description('Parse and explain cron expression')
        .argument('<expression>', 'Cron expression (e.g., "0 5 * * *")')
        .addHelpText('after', `
Examples:
  $ jai1 utils cron "0 5 * * *"
  $ jai1 utils cron "*/15 * * * *"
  $ jai1 utils cron "0 0 1 * *"
  $ jai1 utils cron "0 9-17 * * 1-5"
  $ jai1 utils cron "30 2 * * 0"
`)
        .showHelpAfterError('(add --help for additional examples)')
        .action(async (expression) => {
            await handleCronParse(expression);
        });

    return cmd;
}
